import { createColumnHelper } from "@tanstack/react-table";
import { IMechanic } from "./utils/Mechanic-utils";
import MechanicActionButton from "./utils/MechanicActionsButtons";
import Chip from "@mui/material/Chip";
import { usePermission } from "../../../../hooks/usePermissions";
import { Modules, Permissions } from "../../../Users/Roles/roles-utils";

const columnHelper = createColumnHelper<IMechanic>();

const MechanicColumn = () => {
  const hasEditPermission = usePermission(
    Modules.mmdMech.accessKey,
    Permissions.edit
  );
  const hasDeletePermission = usePermission(
    Modules.mmdMech.accessKey,
    Permissions.delete
  );

  return [
    columnHelper.accessor("id", {
      id: "id",
      header: "Item No",
      cell: ({ row }) => row.index + 1,
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    columnHelper.accessor("name", {
      id: "name",
      header: "Name",
      cell: (row) => row.renderValue(),
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    columnHelper.accessor("type", {
      id: "type",
      header: "Labor Type",
      cell: (row) => row.renderValue(),
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    columnHelper.accessor("isActive", {
      id: "isActive",
      header: "Status",
      cell: (row) => (
        <Chip
          label={row.getValue() ? "Active" : "Inactive"}
          color={row.getValue() ? "primary" : "warning"}
          style={{ color: row.getValue() ? "white" : "white", height: "25px" }}
        />
      ),
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    ...(hasEditPermission || hasDeletePermission
      ? [
          columnHelper.display({
            id: "actions",
            header: "Action",
            cell: ({ row }) => (
              <MechanicActionButton
                Mechanics={row.original}
                hasEditPermission={hasEditPermission}
                hasDeletePermission={hasDeletePermission}
              />
            ),
            enableHiding: false,
          }),
        ]
      : []),
  ];
};

export default MechanicColumn;
